import { backendRequest } from "./backend-auth";
import { formBody, request } from "./http";
import { clearNavigationCache } from "./venstremeny/cache";
import { backendOnly, loginPath } from "./frontend-mode";

// The two cookies may identify separate sessions. Revoke both; each operation is safe to retry.
export const logout = async () => {
    clearNavigationCache();
    if (!backendOnly()) {
        await request(`default.asp`, {
            method: `POST`, headers: { "X-Energikilden-Request": `1` }, body: formBody({ action: `logout` })
        });
    }
    await backendRequest(`/api/sessions/current`, `DELETE`, undefined, false);
};

export const bindLogout = (link: HTMLAnchorElement) => {
    let pending = false;
    const contents = Array.from(link.childNodes);
    const status = document.createElement(`span`);
    status.setAttribute(`role`, `alert`);
    link.addEventListener(`click`, async event => {
        event.preventDefault();
        if (pending) return;
        status.remove();
        pending = true;
        link.setAttribute(`aria-disabled`, `true`);
        link.textContent = `Logger ut …`;
        try {
            await logout();
            location.assign(loginPath());
        } catch {
            status.textContent = ` Kunne ikke fullføre utloggingen. Trykk Logg ut for å prøve igjen.`;
            link.after(status);
            link.focus();
        } finally {
            pending = false;
            link.removeAttribute(`aria-disabled`);
            link.replaceChildren(...contents);
        }
    });
};
